import styled               from 'styled-components';

import { ButtonVariants   } from 'src/components/common/button';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors,
         cssFlexRow       } from 'src/providers/theme/shared';



type RevokeTokenDialogLookAndFeel = {
  paddings: number[];

  captionTypo: Typo;
  captionColor: string;

  warningTypo: Typo;
  warningColor: string;

  actionsGap: number;

  cancelButtonVariant: ButtonVariants;
  acceptButtonVariant: ButtonVariants;
}

const revoketokendialog_light: RevokeTokenDialogLookAndFeel = {
  paddings: [20, 20],

  captionTypo: themeTypos.GRTSKREG_W500_S16_LH22,
  captionColor: themeColors.TextNeutralText100,

  warningTypo: themeTypos.GRTSKREG_W400_S14_LH16,
  warningColor: themeColors.TextNeutralText100,

  actionsGap: 16,

  cancelButtonVariant: 'secondary',
  acceptButtonVariant: 'cancel',
}

export type RevokeTokenDialogVariants = 'light';

export const revoketokendialog_variants: Map<RevokeTokenDialogVariants, RevokeTokenDialogLookAndFeel> = 
  new Map<RevokeTokenDialogVariants, RevokeTokenDialogLookAndFeel>([
    ['light', revoketokendialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: RevokeTokenDialogLookAndFeel
}>`
  ${cssFlexColumn};

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
  background-color: ${themeColors.SurfaceBackgroundPrimary};
  border-radius: 16px;
`

export const Caption = styled.div<{
  lookAndFeel: RevokeTokenDialogLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Warning = styled.div<{
  lookAndFeel: RevokeTokenDialogLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.warningTypo)};
  color: ${(args) => args.lookAndFeel.warningColor};
`

export const Actions = styled.div<{
  lookAndFeel: RevokeTokenDialogLookAndFeel
}>`
  ${cssFlexRow};
  align-self: flex-end;

  gap: ${(args) => args.lookAndFeel.actionsGap}px;

  & > * {
    border-radius: 99px;
  }
`